import React, { useState } from 'react'
import { PostApiAction } from '../../redux/action/action'
import { useDispatch } from 'react-redux';

export default function Model(props) {
  const [fname, setFname] = useState("")
  const [lname, setLname] = useState("")
  const [email, setEmail] = useState("")

  const dispatch = useDispatch()

  const fnameHandler = (e) =>{
    setFname(e.target.value)
  }
  const lnameHandler = (e) =>{
    setLname(e.target.value)
  }
  const emailHandler = (e) =>{
    setEmail(e.target.value)
  }

  const clickHandler = (e) =>{
    e.preventDefault();
    const finalData={
      fname : fname,
      lname : lname,
      email : email
    }
    console.log(finalData)
    dispatch(PostApiAction(finalData));
    alert("Data submitted successfully")
  }
  return (
    <>
        {/* Modal start  */}
        <div className="modal fade" id={props.id} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">Update Your Data {props.id}</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-6">
                    <input type="text" className="form-control" placeholder="First name" aria-label="First name" onChange={(e)=>fnameHandler(e)} />
                  </div>
                  <div className="col-lg-6">
                    <input type="text" className="form-control" placeholder="Last name" aria-label="Last name" onChange={(e)=>lnameHandler(e)} />
                  </div>
                </div>
                <div className="row pt-3">
                  <div className="col-6">
                    <input type="email" className="form-control" placeholder="Enter Email Here" aria-label="Email" onChange={(e)=>emailHandler(e)} />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" className="btn btn-primary" onClick={(e)=>{clickHandler(e)}}>Update Data</button>
              </div>
            </div>
          </div>
        </div>
        {/* Modal end  */}
    </>
  )
}
